module.exports = __webpack_public_path__ + "img/main.32476e01.svg";